const basicPackageServiceAmounts = {
    "dir_3_e_kyc_of_2_directors": 2500,
    "inc_20a_filing": 1500,
    // "gst_registration": 2000,
    "msme_registration": 2000,
    "trademark_application": 7500,
    "appointment_of_1st_auditor": 5000,
    "roc_annual_filling_package": 10000,
    "1st_income_tax_filing": 3000
};

const standarPackageAmounts = {
    "standard_trademark_application": 7500,
    "standard_appointment_of_1st_auditor": 5000,
    "standard_roc_annual_filling_package": 10000,
    "standard_package_1st_income_tax_filing": 3000
}



let userPackageIncludes = {};
let basicPackageTotalPrice = 4999
let standardPackageTotalPrice = 9999
let addBasicPackageIncludes = {};
let addstandardPackageIncludes = {};
let userIsloggedIn = 0;
let buttonClicked = '';

$(document).ready(() => {
    setUserIncludeFromLocal(userIsLoggedIn)
});

$('.basic-btn-buy, .standard-btn-buy, .premium-btn-buy').click((e) => {
    //localStorage.setItem('last_button_clicked', '.basic-btn-buy');
    if ($(e.target).hasClass('basic-btn-buy')) {
        localStorage.setItem('last_button_clicked', '.basic-btn-buy');
        return;
    }
    else if ($(e.target).hasClass('standard-btn-buy')) {
        localStorage.setItem('last_button_clicked', '.standard-btn-buy');
        return
    }
    else if ($(e.target).hasClass('premium-btn-buy')) {
        localStorage.setItem('last_button_clicked', '.premium-btn-buy');
        return;
    }
})

$('.basic_package').on('click', function () {
    let includeId = $(this).attr('id');
    if (includeId in basicPackageServiceAmounts) {
        if ($(this).is(':checked')) {
            if ((includeId in addBasicPackageIncludes)) {
                return;
            }
            addBasicPackageIncludes[includeId] = parseInt(basicPackageServiceAmounts[includeId]);
            basicPackageTotalPrice += parseInt(basicPackageServiceAmounts[includeId])
            userPackageIncludes[includeId] = parseInt(basicPackageServiceAmounts[includeId]);
        }
        else {
            basicPackageTotalPrice -= parseInt(basicPackageServiceAmounts[includeId])
            delete addBasicPackageIncludes[includeId]
            delete userPackageIncludes[includeId]
        }
    }
    // console.log(addBasicPackageIncludes);
    localStorage.setItem('user_includes', JSON.stringify(userPackageIncludes));
    $('.basic_package_includes').val(JSON.stringify(addBasicPackageIncludes));
    $('.final_basic_price').html(basicPackageTotalPrice + '/-');
})

$('.standard_package').on('click', function () {
    let standardIncludeId = $(this).attr('id');
    if (standardIncludeId in standarPackageAmounts) {
        if ($(this).is(':checked')) {
            if ((standardIncludeId in addstandardPackageIncludes)) {
                return;
            }
            addstandardPackageIncludes[standardIncludeId] = parseInt(standarPackageAmounts[standardIncludeId]);
            standardPackageTotalPrice += parseInt(standarPackageAmounts[standardIncludeId])
            userPackageIncludes[standardIncludeId] = parseInt(standarPackageAmounts[standardIncludeId]);
        }
        else {
            standardPackageTotalPrice -= parseInt(standarPackageAmounts[standardIncludeId])
            delete addstandardPackageIncludes[standardIncludeId]
            delete userPackageIncludes[standardIncludeId]
        }
    }

    localStorage.setItem('user_includes', JSON.stringify(userPackageIncludes));
    $('.standard_package_includes').val(JSON.stringify(addstandardPackageIncludes));
    $('.final_standard_price').html(standardPackageTotalPrice + '/-');
})



function setUserIncludeFromLocal(userIsloggedIn) {
    let retrievedUserIncludes = localStorage.getItem('user_includes');
    let retrieveLastButtonClicked = localStorage.getItem('last_button_clicked');
    // alert(retrieveLastButtonClicked);
    if (retrievedUserIncludes !== null) {
        let userIncludes = JSON.parse(retrievedUserIncludes);

        for (var key in userIncludes) {
            if (userIncludes.hasOwnProperty(key)) {
                $('.' + key).click();
            }
        }

    }
    if (userIsloggedIn == 1) {
        if (retrieveLastButtonClicked !== null) {
            $(retrieveLastButtonClicked).click();
        }
    }
}



$("#regButton").on("click", function (a) {
    $('.danger').text('');
    a.preventDefault();
    var e = $("#regForm").serialize();
    $.ajax({
        url: base_url + "/ajax-register",
        data: e,
        dataType: "json",
        headers: {
            'X-CSRF-Token': csrf
        },
        type: "post",
        beforeSend: function () {
            $("#regButton").html(`<i class="fa fa-spinner fa-spin"></i>`);
        },
        success: function (a) {

            if (a.status == 'OTP_SENT') {
                $("#regButton").html('Register');
                $('.otp-verify-div').html(`
                    <div class="form-group">
                    <input type="text" name="otp" required class="form-control otp" placeholder="Enter OTP sent on E-Mail" value="">
                    <span id="otp-error" class="danger" style="color: red;"></span>
                    </div>
                    `)
                alert(a.msg)
            }
            if (a.msg == 'OTP_verified' && a.download_business_guide == 1) {
                window.location.href = "/download-business-guide";
                //location.reload();
                // return alert('doenload busines');
            }
            if (a.msg == 'OTP_verified') {
                swal('User Register Successfully').then(function () {
                    location.reload();
                });
            }

        },
        error: function (reject) {
            $("#regButton").html('Register');
            if (reject.status === 422) {
                var validationErrors = JSON.parse(reject.responseText).errors;
                //console.log(validationErrors);
                $.each(validationErrors, function (key, val) {
                    $("#" + key + "-error").text(val[0]);
                });
            }
        }
    });
})

$('#register_user_private_limited_company').submit('click', (e) => {
    e.preventDefault()
    var userDetail = $("#register_user_private_limited_company").serialize();
    $.ajax({
        url: APP_URL + "/ajax-register",
        data: userDetail,
        dataType: "json",
        headers: {
            'X-CSRF-Token': csrf
        },
        type: "post",
        beforeSend: function () {
            $("#register_rplc").html(`<i class="fa fa-spinner fa-spin"></i>`);
        },
        success: function (a) {
            if (a.status == 'OTP_SENT') {
                $("#register_rplc").html('Register');
                $('.otp-verify-div').html(`
                    <div class="form-group">
                    <input type="text" name="otp" required class="form-control otp" placeholder="Enter OTP send on email" value="">
                    <span id="otp-error" class="danger" style="color: red;"></span>
                    </div>
                    `)
                alert(a.msg)
            }
            if (a.msg == 'OTP_verified') {
                swal('User Register Successfully').then(function () {
                    location.reload();
                });
            }

        },
        error: function (reject) {
            $("#register_rplc").html('Register');
            if (reject.status === 422) {
                var validationErrors = JSON.parse(reject.responseText).errors;
                //(validationErrors);
                $.each(validationErrors, function (key, val) {

                    $("#" + key + "-error").text(val[0]);
                    //console.log($("#" + key + "-error").text(val[0]))
                });
            }
        }
    })
});







